<!--? About Area Start -->
<section class="about-area section-padding30">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-12">
        <!-- about-img -->
        <div class="about-img">
          <img src="resources/img/gallery/matteo2.jpg" alt="">
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="about-caption">
          <!-- Section Tittle -->
          <div class="section-title section-title3 mb-35">
            <span>ABOUT OUR GYM</span>
            <h1>Safe Body building proper Solutions That Saves our Valuable Time!</h1>
          </div>
          <p class="pera-top">Brook presents your services with flexible, convenient and cdpose layouts. You can select your favorite layouts & elements for cular ts with unlimited ustomization
            possibilities. Pixel-perfect replication of the designers is intended.</p>
          <p class="mb-65 pera-bottom">Brook presents your services with flexible, convefnient and chient anipurpose layouts. You can select your favorite layouts.</p>
          <a href="from.html" class="btn">became a member</a>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- About-2 Area End -->
